export default __webpack_public_path__ + "static/media/oj.b0029c7b.jpeg";